module.exports = __webpack_public_path__ + "static/media/caret_up_down.00a7a673.svg";